<template>
  <router-link :to="linkTo">
    {{ nameAbb }}
  </router-link>
</template>

<script setup lang="ts">
  import {computed} from 'vue';
  import {ROUTES} from '@/router/index.router';
  import {log} from '@/utils/logger';
  import {RendererProps} from '@/components/stats/renderer/renderer.model';

  const props = defineProps<{
    props: RendererProps;
  }>();

  const playerId = computed(() => String(props.props.value));
  const firstName = computed(() => String(props.props.data.firstName ?? ''));
  const lastName = computed(() => String(props.props.data.lastName ?? ''));

  const linkTo = computed(() => ({name: ROUTES.STATS_PLAYER, params: {playerId: playerId.value}, query: {nonavbar: 1}}));

  const nameAbb = computed(() => {
    if (!firstName.value && !lastName.value) {
      log.warn(`no first/last-name for ${playerId.value}`);
      return playerId.value;
    }
    const firstAbb = firstName.value ? `${firstName.value.charAt(0)}. ` : '';
    return `${firstAbb}${lastName.value}`;
  });
</script>
